import { useEffect } from "react";
import { H2, P, UL } from "./legal";

/** Static privacy-policy page served at /polityka-prywatnosci (text supplied by legal). */
export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Polityka prywatności — wycena.halavach.pl";
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="bg-brand text-white">
        <div className="max-w-3xl mx-auto px-6 py-10">
          <p className="text-sm uppercase tracking-widest opacity-70">Halavach Real Estate</p>
          <h1 className="mt-2 text-3xl md:text-4xl font-bold">Polityka prywatności</h1>
          <p className="mt-2 opacity-80">
            Kalkulator wyceny nieruchomości wycena.halavach.pl · Data obowiązywania: 23.07.2026
          </p>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10 pb-16">
        <H2>1. Postanowienia ogólne</H2>
        <P>
          Niniejsza Polityka prywatności określa zasady przetwarzania danych osobowych
          użytkowników korzystających z internetowego kalkulatora wyceny nieruchomości
          dostępnego pod adresem: https://wycena.halavach.pl
        </P>
        <P>
          Kalkulator umożliwia użytkownikowi uzyskanie orientacyjnej informacji o wartości
          nieruchomości na podstawie podanych parametrów. W celu otrzymania wyniku wyceny
          użytkownik podaje dane dotyczące nieruchomości oraz numer telefonu, który jest
          następnie weryfikowany za pomocą kodu SMS.
        </P>
        <P>
          Po dokonaniu weryfikacji numeru telefonu dane mogą zostać wykorzystane przez
          Administratora w celu kontaktu z użytkownikiem w sprawach związanych z wyceną
          nieruchomości.
        </P>

        <H2>2. Administrator danych osobowych</H2>
        <P>
          Administratorem danych osobowych użytkowników korzystających z kalkulatora wyceny
          nieruchomości jest:
        </P>
        <P>
          <strong>HALAVACH GROUP SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ</strong>
          <br />
          Rondo Ignacego Daszyńskiego 2B / 26/37
          <br />
          00-843 Warszawa, Polska
          <br />
          KRS: 0000987370 · NIP: 8241816339 · REGON: 522828150
        </P>
        <P>dalej zwana: „Administratorem”.</P>
        <P>
          Administrator decyduje o celach i sposobach przetwarzania danych osobowych
          użytkowników korzystających z kalkulatora. Administrator przetwarza dane osobowe
          zgodnie z przepisami Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679
          z dnia 27 kwietnia 2016 r. (RODO) oraz obowiązującymi przepisami prawa dotyczącymi
          ochrony danych osobowych.
        </P>

        <H2>3. Jakie dane przetwarzamy</H2>
        <P>W związku z korzystaniem z kalkulatora Administrator może przetwarzać następujące dane:</P>
        <P>
          <strong>Dane kontaktowe:</strong>
        </P>
        <UL items={["numer telefonu,", "adres e-mail (jeżeli użytkownik zdecyduje się go podać)."]} />
        <P>
          <strong>Dane dotyczące nieruchomości:</strong>
        </P>
        <UL
          items={[
            "miejscowość,",
            "ulica,",
            "numer budynku,",
            "powierzchnia nieruchomości,",
            "liczba pokoi,",
            "piętro,",
            "rok budowy,",
            "stan wykończenia,",
            "cel wyceny.",
          ]}
        />
        <P>
          Dane dotyczące nieruchomości mogą stanowić dane osobowe w przypadku ich połączenia
          z numerem telefonu lub innymi informacjami umożliwiającymi identyfikację użytkownika.
        </P>
        <P>
          <strong>Dane dotyczące zgód:</strong>
        </P>
        <UL
          items={[
            "treść zaakceptowanych zgód,",
            "data i godzina ich udzielenia,",
            "adres IP,",
            "informacje dotyczące przeglądarki internetowej (user agent).",
          ]}
        />

        <H2>4. Cele i podstawy prawne przetwarzania danych</H2>
        <P>Dane osobowe są przetwarzane w następujących celach:</P>
        <P>
          <strong>Przygotowanie orientacyjnej wyceny nieruchomości</strong>
          <br />
          Dane nieruchomości są przetwarzane w celu przygotowania kalkulacji orientacyjnej
          wartości nieruchomości.
          <br />
          Podstawa prawna: art. 6 ust. 1 lit. b RODO – wykonanie usługi na żądanie użytkownika.
        </P>
        <P>
          <strong>Kontakt z użytkownikiem w sprawie wyceny</strong>
          <br />
          Numer telefonu oraz inne dane kontaktowe mogą być wykorzystywane w celu kontaktu
          z użytkownikiem, doprecyzowania informacji dotyczących nieruchomości oraz
          przedstawienia informacji związanych z procesem wyceny.
          <br />
          Podstawa prawna: art. 6 ust. 1 lit. a RODO – zgoda użytkownika.
        </P>
        <P>
          <strong>Obsługa zapytań oraz zabezpieczenie przed roszczeniami</strong>
          <br />
          Administrator może przechowywać informacje dotyczące zapytań użytkowników w celu
          obsługi zgłoszeń oraz ochrony swoich praw.
          <br />
          Podstawa prawna: art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes Administratora.
        </P>
        <P>
          <strong>Marketing usług Administratora</strong>
          <br />
          Jeżeli użytkownik wyrazi dodatkową zgodę, dane mogą być wykorzystywane w celu
          przesyłania informacji handlowych oraz prowadzenia komunikacji marketingowej.
          <br />
          Podstawa prawna: art. 6 ust. 1 lit. a RODO – zgoda użytkownika.
        </P>

        <H2>5. Weryfikacja numeru telefonu</H2>
        <P>
          W celu ograniczenia liczby fikcyjnych zgłoszeń oraz potwierdzenia poprawności numeru
          telefonu Administrator wykorzystuje mechanizm weryfikacji SMS. W tym celu numer
          telefonu może zostać przekazany dostawcy usług SMS:
        </P>
        <P>
          <strong>SMSAPI sp. z o.o.</strong>
        </P>
        <P>
          Zakres przekazywanych danych obejmuje numer telefonu oraz informacje techniczne
          niezbędne do realizacji wysyłki wiadomości.
        </P>

        <H2>6. Odbiorcy danych osobowych</H2>
        <P>Dane osobowe mogą być przekazywane następującym kategoriom odbiorców:</P>
        <P>
          <strong>System CRM</strong>
          <br />
          Administrator korzysta z systemów CRM służących do obsługi zapytań klientów. Zakres
          danych przekazywanych do systemu CRM może obejmować:
        </P>
        <UL
          items={[
            "numer telefonu,",
            "adres e-mail,",
            "dane nieruchomości,",
            "wynik orientacyjnej wyceny,",
            "informacje dotyczące kontaktu z użytkownikiem.",
          ]}
        />
        <P>
          <strong>Dostawca infrastruktury hostingowej</strong>
          <br />
          Administrator korzysta z usług dostawców infrastruktury technicznej zapewniających
          działanie kalkulatora, serwerów oraz baz danych. Obecnie wykorzystywanym dostawcą
          może być: Hetzner Online GmbH
        </P>
        <P>
          <strong>Dostawcy usług technicznych</strong>
          <br />
          Administrator może korzystać z usług podmiotów zapewniających:
        </P>
        <UL
          items={[
            "utrzymanie aplikacji,",
            "rozwój systemu,",
            "bezpieczeństwo infrastruktury,",
            "wsparcie techniczne.",
          ]}
        />
        <P>
          Podmioty te przetwarzają dane wyłącznie na podstawie zawartych umów oraz zgodnie
          z instrukcjami Administratora.
        </P>
        <P>
          <strong>Usługi geokodowania</strong>
          <br />
          W celu ustalenia lokalizacji nieruchomości adres nieruchomości może zostać przekazany
          do usługi geokodowania: Główny Urząd Geodezji i Kartografii (GUGiK). Przekazywany
          jest wyłącznie adres nieruchomości niezbędny do realizacji funkcji technicznej.
        </P>

        <H2>7. Cookies i narzędzia analityczne</H2>
        <P>Serwis może wykorzystywać pliki cookies oraz podobne technologie. Cookies mogą być wykorzystywane w celu:</P>
        <UL
          items={[
            "zapewnienia prawidłowego działania serwisu,",
            "zapamiętywania ustawień użytkownika,",
            "analizy sposobu korzystania z serwisu,",
            "mierzenia skuteczności działań marketingowych,",
            "prowadzenia działań reklamowych.",
          ]}
        />
        <P>Administrator może korzystać z narzędzi takich jak:</P>
        <UL items={["Google Tag Manager,", "Google Analytics,", "Meta Pixel."]} />
        <P>
          Narzędzia te mogą przetwarzać informacje dotyczące aktywności użytkownika w serwisie,
          w szczególności:
        </P>
        <UL
          items={[
            "informacje o urządzeniu,",
            "informacje o wizytach,",
            "źródło wejścia na stronę,",
            "interakcje z serwisem.",
          ]}
        />
        <P>
          Nieobowiązkowe cookies oraz technologie marketingowe są uruchamiane wyłącznie po
          uzyskaniu zgody użytkownika. Użytkownik może w każdej chwili zmienić ustawienia
          cookies za pomocą dostępnego mechanizmu zarządzania zgodami.
        </P>

        <H2>8. Okres przechowywania danych</H2>
        <P>Dane osobowe użytkowników są przechowywane:</P>
        <UL
          items={[
            "przez okres niezbędny do obsługi zapytania dotyczącego wyceny,",
            "maksymalnie przez okres 3 lat od ostatniego kontaktu z użytkownikiem.",
          ]}
        />
        <P>
          Dane dotyczące udzielonych zgód mogą być przechowywane przez okres niezbędny do
          wykazania ich udzielenia. Po upływie wskazanego okresu dane są usuwane lub
          anonimizowane.
        </P>

        <H2>9. Prawa użytkownika</H2>
        <P>Użytkownikowi przysługuje prawo do:</P>
        <UL
          items={[
            "dostępu do swoich danych,",
            "uzyskania kopii danych,",
            "sprostowania danych,",
            "usunięcia danych,",
            "ograniczenia przetwarzania,",
            "wniesienia sprzeciwu wobec przetwarzania,",
            "cofnięcia zgody w dowolnym momencie.",
          ]}
        />
        <P>
          Cofnięcie zgody nie wpływa na zgodność z prawem przetwarzania dokonanego przed jej
          cofnięciem. Użytkownik ma również prawo wniesienia skargi do: Prezesa Urzędu Ochrony
          Danych Osobowych.
        </P>

        <H2>10. Bezpieczeństwo danych</H2>
        <P>
          Administrator stosuje odpowiednie środki techniczne i organizacyjne mające na celu
          ochronę danych osobowych przed:
        </P>
        <UL
          items={[
            "utratą,",
            "nieuprawnionym dostępem,",
            "ujawnieniem,",
            "zmianą,",
            "wykorzystaniem niezgodnym z prawem.",
          ]}
        />

        <H2>11. Charakter wyceny</H2>
        <P>Wynik przedstawiany przez kalkulator ma charakter wyłącznie orientacyjny. Nie stanowi:</P>
        <UL
          items={[
            "operatu szacunkowego,",
            "wyceny sporządzonej przez rzeczoznawcę majątkowego,",
            "wiążącej oferty sprzedaży lub zakupu nieruchomości.",
          ]}
        />
        <P>
          Ostateczna wartość nieruchomości może różnić się od wyniku przedstawionego przez
          kalkulator.
        </P>

        <H2>12. Kontakt</H2>
        <P>
          W sprawach dotyczących przetwarzania danych osobowych użytkownik może skontaktować
          się z Administratorem za pomocą danych kontaktowych wskazanych na stronie
          internetowej Administratora.
        </P>
        <P>
          <strong>HALAVACH GROUP SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ</strong>
        </P>

        <div className="mt-12">
          <a href="/" className="text-brand underline font-medium">
            ← Wróć do wyceny
          </a>
        </div>
      </main>
    </div>
  );
}
